import {TextField, Autocomplete} from '@mui/material';
import {useContext} from 'react';
import AuthContext from '../../context/AuthContext';


export default function AutocOneTrgCat(props: any) {
    let {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)

    const {name, valsArr, trgObj, setTrgObj, setTrgCatFeats, setUsemapExists} = props
    let val = trgObj.catName || ''
    let isOpen:boolean = true
    let fieldBgColor: string = isOpen ? 'white' : '#e9ecef'

    return (
        <Autocomplete
            key={1}
            value={val}
            onChange={(event, newValue) => {
                // console.log('OnChange: ', newValue)

                if (!newValue) {
                    for (let k in trgObj) {
                        trgObj[k as keyof typeof trgObj] = ''
                    }
                    setTrgObj((prevState: any) => {
                        return {...prevState, trgObj: trgObj}
                    })

                    setUsemapExists(false)

                } else {
                    // getting all trg features of the trg category
                    fetch(`${serverIP}/featusemapgettrgfeats/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + String(authTokens.access)
                        },
                        body: JSON.stringify({catUID: newValue.catUID}),
                    }).then(res => res.json())
                        .then((data) => {
                            // console.log('Data: ', data)
                            if (data.length > 0) {
                                setTrgCatFeats(data)    // setting array with Features to Autocomplete
                            }
                        })

                    // setting Trg Object with Trg Cat values
                    setTrgObj((prevState: any) => {
                        return {
                            ...prevState,
                            catUID: newValue.catUID,    // used in 'usemapvalidate'
                            catID: newValue.catID,
                            catName: newValue.catName
                        }
                    })
                }
            }}

            isOptionEqualToValue={(option, value) => option.value === value.value}

            readOnly={!isOpen}
            disablePortal
            autoHighlight
            forcePopupIcon={false}
            size='small'
            id='combo-box-demo'
            options={valsArr}
            sx={{width: 'auto'}}
            ListboxProps={
                {style: {fontSize: '0.8rem', fontFamily: "'Inter', sans-serif", color: 'black'}}}

            renderInput={(params) =>
                <TextField
                    {...params}
                    label=""
                    style={{backgroundColor: fieldBgColor}}
                    // InputProps={{
                    //     style: {height: 30}
                    // }}
                />}

        />
    );
}
